import Image from 'next/image';
import { useSelector } from 'react-redux';

import { selectors } from '@/domains/mini-market';

export const MainImage = ({ isModal, setModalActive, data }) => {
  const { selectedImage } = useSelector(selectors.selectMiniMarket);
  return (
    <Image
      alt={data?.name}
      title={data?.name}
      onClick={() => setModalActive(true)}
      src={selectedImage}
      width={!isModal ? 450 : 590}
      height={!isModal ? 466 : 590}
      objectFit='contain'
      itemScope
      itemType='https://schema.org/ImageObject'
    />
  );
};
